import { OpportunitiesClient } from '../apiClient/client';
import { AppThunkAction } from '../applicationStates';
import * as models from './opportunetisModels';

// -----------------
// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
// They do not themselves have any side-effects; they just describe something that is going to happen.
// Use @typeName and isActionType for type detection that works even after serialization/deserialization.

interface SetOpportunities {
    type: 'SET_OPPORTUNITIES';
    data: models.OpportunitiesObject[];
}
interface GetOpportunities {
    type: 'GET_OPPORTUNITIES';
    data: models.OpportunitiesObject[];
}
interface SetLoading {
    type: 'SET_LOADING_OPPORTUNITIES';
    data: boolean;
}

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
export type KnownAction = SetOpportunities | SetLoading | GetOpportunities;

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).

export const opportunitiesActionCreators = {
    setOpportunities: (data: models.OpportunitiesObject[]) =>
        <SetOpportunities>{
            type: 'SET_OPPORTUNITIES',
            data: data
        },
    GetOpportunities: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({ type: 'SET_LOADING_OPPORTUNITIES', data: true });
        const OC: OpportunitiesClient = new OpportunitiesClient();
        OC.get().then((response) => {
            const opportunities: models.OpportunitiesObject[] = Array<any>();
            response.map((obj) => {
                // console.log(obj.industry);
                opportunities.push(
                    new models.OpportunitiesObject(
                        obj.city ? obj.city : undefined,
                        obj.company ? obj.company : undefined,
                        obj.createdDate ? obj.createdDate : undefined,
                        obj.email ? obj.email : undefined,
                        obj.phoneNumber ? obj.phoneNumber : undefined,
                        obj.name ? obj.name : undefined,
                        obj.state ? obj.state : undefined,
                        obj.topic ? obj.topic : undefined,
                        obj.opportunityId ? obj.opportunityId : undefined,
                        obj.description ? obj.description : undefined,
                        obj.rate ? obj.rate : undefined,
                        obj.statusCode ? obj.statusCode : undefined,
                        obj.industry ? obj.industry : undefined
                    )
                );
            });

            if (response !== (null || undefined)) {
                dispatch({ type: 'SET_OPPORTUNITIES', data: opportunities });
                dispatch({ type: 'SET_LOADING_OPPORTUNITIES', data: false });
            } else {
                dispatch({ type: 'SET_LOADING_OPPORTUNITIES', data: false });
            }
        });
    },
    setLoading: (data: boolean) => <SetLoading>{ type: 'SET_LOADING_OPPORTUNITIES', data: data }
};



// WEBPACK FOOTER //
// ./src/data/opportuneties/opportunetisActions.ts